<template>
  <div class="content">
    <!-- <img src="../assets/news_banner.png" style="width:100%;height:100%;margin-bottom:-8px;"> -->
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Company</el-breadcrumb-item>
      <el-breadcrumb-item>Events&News</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding:40px 139px 0 139px;height:auto;">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick(activeName)">
        <el-tab-pane :label="v.name" :name="v.year" v-for="(v,index) in contentList" :key= "index">
        </el-tab-pane>
      </el-tabs>
      <div class="news_parent" v-show="activeName != '' && contentList.length > 0">
            <div class="item" style="margin-right:80px;">
              <div class="title">News</div>
              <ul>
                <li v-for="(item, index) in newsList" :key="index" style="display:flex;align-items: center;justify-content: center;margin-bottom:36px" @click="goNewsDetail(item)">
                  <div class="img-sty">
                    <a class="img-hover"><img class="img-wh" :src="item.smallImage" /></a>
                  </div>
                  <div style="flex:1;padding-left:30px;">
                    <p style="font-size:20px;margin-bottom:15px;color:#323232;"><a class="a1">{{ item.title }}</a></p>
                    <p style="font-size:16px;margin-bottom:12px;color:#878787;">{{ item.createTime ? item.createTime.split(' ')[0] : '' }}</p>
                    <p class="p3" style="font-size:16px;line-height:20px;color:#878787;">{{ item.remark }}</p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="item">
              <div class="title">Events</div>
              <ul>
                <li style="display:flex;align-items: center;justify-content: center; margin-bottom:36px" v-for="(item, index) in eventsList" :key="index" @click="goNewsDetail(item)">
                  <div class="img-sty">
                    <a class="img-hover"><img class="img-wh" :src="item.smallImage" /></a>
                  </div>
                  <div style="flex:1;padding-left:30px;">
                    <p style="font-size:20px;margin-bottom:15px;color:#323232;"><a class="a1">{{ item.title }}</a></p>
                    <p style="font-size:16px;margin-bottom:12px;color:#878787;">{{ item.createTime ? item.createTime.split(' ')[0] : '' }}</p>
                    <p class="p3" style="font-size:16px;line-height:20px;color:#878787;">{{ item.remark }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
    </div>
  </div>
</template>
<script>
import {  NewsEventsList } from '@/api/index' ;
    export default {
        name: 'Newsevents',
        data () {
            return {
              activeName: '',
              contentList: [],
              newsList: [],
              eventsList: [],
            }
        },
        watch:{
          activeName(val){
            
          }
        },
        methods: {
          handleClick(activeName){
            this.activeName = activeName
            console.log('handleClick',activeName)
            this.getNewsList();
            this.getEventsList();
          },
          // 获取News
          getNewsList() {
              const params = {
                type: 'News',
                year: this.activeName
              };
              NewsEventsList(params).then((res) => {
                this.newsList = []
                this.newsList = res;
                
              });
          },
          // 获取Events
          getEventsList() {
              const params = {
                type: 'Events',
                year: this.activeName
              };
              NewsEventsList(params).then((res) => {
                this.eventsList = []
                this.eventsList = res;
              });
          },

          getLast3Year() {
            let date = new Date()
            let curYear = date.getFullYear();
            let yserLast = {
              "name":(curYear+1) + '',
              "year":(curYear+1) + '',
            }
            let yser1 = {
              "name":curYear + '',
              "year":curYear + '',
            }
            let yser2 = {
              "name":(curYear-1) + '',
              "year":(curYear-1) + '',
            }

            this.contentList.push(yserLast);
            this.contentList.push(yser1);
            this.contentList.push(yser2);

            if(curYear) this.activeName = curYear+''
            
            console.log(this.activeName);
          },
          // 新闻详情
          goNewsDetail(item) {
            console.log(item, 'items');
            // this.$router.push({name: "Newsevents"});
            this.$router.push({
              path: './Newsdetail',
              query: {
                id: item.id
              }
            });
          },
        },
        mounted() {
          this.getLast3Year();
          this.getNewsList();
          this.getEventsList();
        },
    }
</script>

<style scoped>
.content {
  width:100%;
  height: auto;
}
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
.news_parent {
    display:flex;
    /* width: 85%;
    margin: 115px auto 139px; */
    width:100%;
    align-items: center;
    height: auto;
    /* justify-content: space-between; */
    margin-bottom:100px;
  }
  .news_parent .item {
    /* margin: 0 132px; */
    height: auto;
    /* border-radius:20px;
    background-color:#f5f5f5; */
    /* padding: 60x 0 27px; */
    flex:1;
  }
  .news_parent .item .title {
    text-align:center;
    font-size:30px;
    color:#022032;
    font-weight:bold;
    margin-bottom:47px;
    cursor: pointer;
  }
  .p3 {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
  }
  ::v-deep .el-tabs__nav{
    border: none !important;
  }
  ::v-deep .el-tabs__item{
    border-left: none !important;
    padding: 0;
    width:99px !important;
    height:52px !important;
    line-height:52px !important;
    text-align:center !important;
    color:#8d8d8d !important;
  }
  ::v-deep .el-tabs__item:nth-child(2) {
    padding-left: 0 !important;
  }
  ::v-deep .el-tabs__item:last-child {
    padding-right: 0 !important;
  }
  ::v-deep .el-tabs__item.is-active{
    background-color:#00718c !important;
    color:#fff !important;
    border-radius: 9px 9px 0 0 !important;
    width:99px !important;
    height:52px !important;
    line-height:52px !important;
    text-align:center !important;
  }

  .img-sty {
    width:143px;
    height:143px;
    overflow: hidden;
    max-width:143px;
    max-height:143px;
  }
  .img-hover {
    object-fit: cover;
    transition: all 2s;
    overflow:hidden;
  }
  .img-hover :hover {
	/* 放大1.3倍 */
    transform: scale(1.2);
  }
  .img-wh {
    width:100%;
    height:auto;
    max-height:143px;
    max-width:100%;
  }
  body::-webkit-scrollbar {
  display: none;
  }
  *::-webkit-scrollbar { 
    width: 0 !important
  }
  ::v-deep .el-breadcrumb__inner.is-link {
  font-weight: 400;
}
</style>